import {
    Container,
    Wrapper
} from './Footer.styled'

const Footer = () => {
    return (
        <Container>
            <Wrapper>
                <p>©2022 by WOORIE WE LLC.</p>
            </Wrapper>
        </Container>
    )
}

export default Footer